import { DashboardResultType } from '@api/domain/types';

import { COLOR_BY_VARIANT } from '@v2/pages/dashboard/common/components/DashboardList/components/DashboardListBar/constants';
import { DashboardListBarVariant } from '@v2/pages/dashboard/common/components/DashboardList/components/DashboardListBar/types';
import type { DashboardOverviewTopBlockProps } from '@v2/pages/dashboard/modules/overview/components/DashboardOverview/components/DashboardOverviewTopBlock';

interface UseManageDashboardOverviewTopBlockParams
  extends Pick<DashboardOverviewTopBlockProps, 'dashboardOverallData' | 'resultType'> {}

export const useManageDashboardOverviewTopBlock = ({
  dashboardOverallData,
  resultType,
}: UseManageDashboardOverviewTopBlockParams) => {
  const positiveSeconds = dashboardOverallData?.positiveScopeTotalTimeTotalInSeconds ?? 0;
  const negativeSeconds = Math.abs(dashboardOverallData?.negativeScopeTotalTimeTotalInSeconds ?? 0);
  const positiveCount = dashboardOverallData?.positiveScopeTotalCount ?? 0;
  const negativeCount = dashboardOverallData?.negativeScopeTotalCount ?? 0;
  const totalSeconds = positiveSeconds + negativeSeconds;
  const positiveRatio = totalSeconds === 0 ? 0 : positiveSeconds / totalSeconds;
  const netSeconds = negativeSeconds - positiveSeconds;
  const isLoss = netSeconds > 0;
  const accentColor = isLoss ? 'System/Light/Red' : 'System/Light/Green';

  const isActual = resultType === DashboardResultType.Actual;
  const triggerColor = isActual ? COLOR_BY_VARIANT[DashboardListBarVariant.Actual] : accentColor;
  const triggerLabel = isActual ? 'ACTUAL' : isLoss ? 'LOSS' : 'GAIN';

  return {
    positiveSeconds,
    negativeSeconds,
    positiveCount,
    negativeCount,
    positiveRatio,
    netSeconds,
    isLoss,
    accentColor,
    triggerColor,
    triggerLabel,
  };
};
